import {LOAD_REQUEST, FINISH_REQUEST} from '../constants/constants'

export default (pendentes = {que: 0, isloading: false}, action) => {
    switch(action.type){
        case LOAD_REQUEST:            
            return {que : pendentes.que+1, isloading : true};
        case FINISH_REQUEST:
            if(pendentes.que-1==0)
                return {que : 0, isloading : false};
            else{
                let n = pendentes.que-1;
                if(n<0) n = 0
                return {que : n, isloading : true};
            }
    }
    return pendentes
}


// WEBPACK FOOTER //
// ./src/reducers/pendente.js